export default "__VITE_ASSET__9ce2a856__"